<template>
  <div class="ShoppingCart-new">
    <transition name="fade" mode="out-in" v-if="isLoading">
      <app-loading
        class="fullscreen"
        :is-loading="isLoading"
        :spinner-color="'#1474a4'"
      />
    </transition>
    <div v-else class="container container-cart container-wider">
      <h2 class="title">
        {{ $t('shopping_cart.title', 'Shopping Cart') }}
      </h2>

      <div class="ShoppingCart-new_body">
        <app-loading
          class="translucence"
          v-if="isReloading"
          component="looping-rhombuses-spinner"
          :animation-duration="2000"
          :size="30"
        />

        <section class="ShoppingCartItems">
          <div class="ShoppingCartItems-type" v-for="group in cartDetails.groups" :key="group.name">
            <div class="ShoppingCartItems_header">
              <h3 class="title-subscriptionType">
                {{ $t(`shopping_cart.bundles.type.${group.name}`, `${group.name}`) }}
              </h3>
            </div>

            <div class="ShoppingCartItems_body">
              <div class="Product no-gutters" v-for="(bundle, index) in group.items" :key="index">
                <button
                  class="Product_btn-remove"
                  v-if="bundlesWithQuantity.length > 1"
                  @click="removeBundle(bundle.name, bundle.philips12NC)"
                >
                  {{ $t('shopping_cart.btn.remove', 'remove') }}
                </button>
                <div class="img-holder col-md-3">
                  <img class="Product_img" :src="bundle.image" :alt="bundle.title">
                </div>
                <div class="Product_text col-md-4">
                  <h3 class="Product_name">{{ bundle.title }}</h3>
                  <p class="Product_description" v-if="bundle.description" v-html="bundle.description"></p>
                   <div class="OFSmsg" v-show="bundleflag">   
                     {{ $t('bundleOutOfStockMessage', 'Product is currently out of stock..') }} 
                    </div>
                </div>
                <app-spinner :rhombus-size="rhombusSize" :color="color" v-if="Loading"/>
                <div class="Product_price col-auto col-md-3">
                  <!-- oneTime charge -->
                  <p class="Product_price_item" v-if="bundle.oneTimeCharge">
                    <span class="discount" v-if="bundle.oneTimeCharge.discounts">
                      {{ bundle.oneTimeCharge.discounted | formatCurrency }}
                    </span>
                    <span class="origin" :class="{ 'has-discount': !!bundle.oneTimeCharge.discounts }" >
                      {{ bundle.oneTimeCharge.original | formatCurrency }}
                    </span>
                    <span class="font-weight-light" v-if="group.name !== 'BuyNow'">
                      {{ $t('common.product.price.oneTimeCharge', 'for first payment*') }}
                    </span>
                    <span class="font-weight-light" v-if="group.name ==='BuyNow'">
                      {{ $t('common.product.price.buyNow.oneTimeCharge', 'one-time payment') }}
                    </span>
                  </p>
                  <!-- monthly charge -->
                  <p class="Product_price_item" v-if="bundle.monthlyCharge">
                    <span class="discount" v-if="bundle.monthlyCharge.discounts">
                      {{ bundle.monthlyCharge.discounted | formatCurrency }}
                    </span>
                    <span class="origin" :class="{ 'has-discount': !!bundle.monthlyCharge.discounts }" >
                      {{ bundle.monthlyCharge.original | formatCurrency }}
                    </span>
                    <span class="font-weight-light">
                      {{ $t('common.product.price.monthlyCharge', 'monthly charge') }}
                    </span>
                    <span class="font-weight-light">
                      {{ $t('shopping_cart.startingOn', 'starting on') }} {{ bundle.monthlyCharge.beginDate | formatLocalDate }}
                    </span>
                  </p>
                  <!-- quarterly charge -->
                  <p class="Product_price_item" v-if="bundle.quarterlyCharge">
                    <span class="discount" v-if="bundle.quarterlyCharge.discounts">
                      {{ bundle.quarterlyCharge.discounted | formatCurrency }}
                    </span>
                    <span class="origin" :class="{ 'has-discount': !!bundle.quarterlyCharge.discounts }" >
                      {{ bundle.quarterlyCharge.original | formatCurrency }}
                    </span>
                    <span class="font-weight-light">
                      {{ $t('common.product.price.quarterlyCharge', 'quarterly Charge') }}
                    </span>
                    <span class="font-weight-light">
                      {{ $t('shopping_cart.startingOn', 'starting on') }} {{ bundle.quarterlyCharge.beginDate | formatLocalDate }}
                    </span>
                  </p>
                  <!-- semiAnnual charge -->
                  <p class="Product_price_item" v-if="bundle.semiAnnualCharge">
                    <span class="discount" v-if="bundle.semiAnnualCharge.discounts">
                      {{ bundle.semiAnnualCharge.discounted | formatCurrency }}
                    </span>
                    <span class="origin" :class="{ 'has-discount': !!bundle.semiAnnualCharge.discounts }" >
                      {{ bundle.semiAnnualCharge.original | formatCurrency }}
                    </span>
                    <span class="font-weight-light">
                      {{ $t('common.product.price.semiAnnual', 'Semi annual') }}
                    </span>
                    <span class="font-weight-light">
                      {{ $t('shopping_cart.startingOn', 'starting on') }} {{ bundle.semiAnnualCharge.beginDate | formatLocalDate }}
                    </span>
                  </p>
                  <!-- specificMonths charge -->
                  <template v-for="(specificCharge, index) in bundle.specificMonthsCharges">
                    <p class="Product_price_item" :key="index">
                      <span class="discount" v-if="specificCharge.charge.discounts">
                        {{ specificCharge.charge.discounted | formatCurrency }}
                      </span>
                      <span class="origin" :class="{ 'has-discount': !!specificCharge.charge.discounts }" >
                        {{ specificCharge.charge.original | formatCurrency }}
                      </span>
                      <span class="font-weight-light1" v-if="detectedCulture.countryCode === 'CZ'">
                        {{ $t('common.product.price.everyNL', 'Every'  ) }}  {{ specificCharge.specificMonths}}.  {{ $t('common.product.price.specificMonths', 'months') }}
                      </span>
                      <span class="font-weight-light" v-if="detectedCulture.countryCode != 'CZ'">
                        {{ $t('common.product.price.everyNL', 'Every') }} {{ specificCharge.specificMonths }} {{ $t('common.product.price.specificMonths', 'months') }}
                      </span>
                      <span class="font-weight-light">
                        {{ $t('shopping_cart.startingOn', 'starting on') }} {{ specificCharge.charge.beginDate | formatLocalDate }}
                      </span>
                    </p>
                  </template>
                </div>
                <div class="Product_quantity col-md-2">
                  <app-quantity-selector
                    :quantity="bundle.quantity"
                    :diabled-quantity-selector="diabledQuantitySelector"
                    :bundle-name="bundle.name"
                    :ctn="bundle.philips12NC"
                    @update-quantity="updateBundleQuantity($event, bundle.name)"
                  />
                </div>
              </div>
              <product-usp
                v-if="!isFamilyPack"
                class ="SingleBundleUsp"
                :usp="cartDetails.groups[0].items[0].usp"
              />
            </div>

             <!-- <div class="cancelDE" v-if="detectedCulture.countryCode === 'DE'">
          <div class="demo">
            <p >{{ $t('checkout.personalDetails.common.createAccount.login.tips1', 'Subscriptions') }}</p>
           <h2>{{ $t('checkout.personalDetails.common.createAccount.login.subTips1', 'Easy cancellation of your contracts') }}</h2>
          </div>
             <div class="demo1">
            <app-button
              @click.prevent="openModalStep2"
            >
              {{ $t('checkout.personalDetails.common.createAccount.button.login1', 'Cancel contracts here') }}
            
            </app-button>


            <app-modal name="newFlowCancel1"  :clickToClose="false" width="500px">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="newFlowCancelDE_popUp">
              <h2>
                {{ $t('checkout.personalDetails.common.mailsub', "We have received your request to terminate the contract.") }}
              </h2>
                <p >{{ $t('checkout.personalDetails.common.createAccount.login.tips7', 'You will receive a confirmation to your mail') }}</p>
          </div> </div></div>
           <app-button
                 
              
            
               @click.prevent="test"
               
                  
                >
                  {{ $t('checkout.personalDetails.cancellation.popUp.closebutton', "close") }}
                </app-button>
               
               </app-modal>
               
 
          
  
        <app-modal name="newFlowCancel" :clickToClose="false" width="500px">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="newFlowCancelDE_popUp">
              <h2>
                {{ $t('checkout.personalDetails.common.popUp.sub', "Please fill the Subscription information you want to terminate.") }}
              </h2>
                <p >{{ $t('checkout.personalDetails.common.createAccount.msg', 'you can find required subscription information on your invoice') }}</p>

            
     
      <form class="Detail_body" >
        <div class="contentDE">
          <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.firstName', 'First name')"
            :placeholder="$t('checkout.personalDetails.placeholder.firstName', 'First name')"
            v-model.trim="name"
            :top-label="topLabel"
          />
           <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.lastName', 'Surname')"
            :placeholder="$t('checkout.personalDetails.placeholder.lastName', 'Surname')"
            v-model.trim="surName"
            :top-label="topLabel"
          />
          <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.email', 'E-mail Address')"
            :placeholder="$t('checkout.personalDetails.placeholder.email', 'E-mail Address')"
            v-model.trim="fromEmail"
            :top-label="topLabel"
          />
           <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.number', 'Subscription Number')"
            :placeholder="$t('checkout.personalDetails.placeholder.number', 'Subscription Number')"
            v-model.trim="subscriptionNumber"
        
            :top-label="topLabel"
          />
        </div>
          </form>

              <div class="modal-button-warpper">
                
        
                <app-button
                 
               type="submit"
                 
                  
                  :disabled="(!name || !surName || !fromEmail || !subscriptionNumber)"
            
               @click.prevent="openModalStep3"
               
                  
                >
                
                  {{ $t('checkout.personalDetails.cancellation.popUp.button.terminate', "Terminate contract") }}
                </app-button>
              </div>  
            </div>
          </div>
        </div>
      </app-modal>
       </div></div> -->

          </div>
        </section>

        <aside>
          <div class="ShoppingCartPayment">
            <checkout-step-cart
              :cart-details-summary="cartDetails.summary"
              :loading="Loading"
              :bundles="bundlesWithQuantity"
            />
          </div>

          <app-button
            type="submit"
            class="AppButton-submitCart"
            @click.prevent="submitCartTask.run()"
            :is-loading="submitCartTask.isActive || isLoding"
            :disabled="Loading || isLoding || bundleflag"
            data-name="ShoppingCart-submitCart"
            @click.native="trackConversion({name: 'interaction', description: 'button:check_out'})"
          >
            {{ $t('shopping_cart.link.checkout', 'Check out') }}
          </app-button>

          <div class="tip-error tip-error-maxQuantity" v-if="!maxQuantityIsValid">
            <p v-for="(bundle, index) in invalidBundles" :key="index">
              <b v-for="(title, index) in bundle.titles" :key="index">
                {{ title }}<template v-if="index !== bundle.titles.length - 1">,</template>
              </b>
              <span v-if="bundle.titles.length > 1">
                {{ $t('shopping_cart.error.tips', 'exceed the maximum order quantity of') }}
                <b>{{ bundle.maxQuantity }}</b>
              </span>
              <span v-else>
                {{ $t('shopping_cart.error.tip', 'exceeds the maximum order quantity of') }}
                <b>{{ bundle.maxQuantity }}</b>
              </span>
            </p>
          </div>

          <div class="tip-error tip-error-maxQuantity" v-if="reachMaxAllowedNumberError">
            <p>
              {{ $t(`validation.${reachMaxAllowedNumberError.code}`, { ...reachMaxAllowedNumberError }) }}
            </p>
          </div>

          <fp-discount-box
            :bundles-with-quantity = bundlesWithQuantity
            :preview-bundle="previewBundle"
            :repead-loading = Loading
          />

          <div class="DeliveryInfo">
            <app-icon name="delivery2" />
            <p class="text">
              <span> {{ $t('checkout.delivey.text', 'Free delivey') }}</span>
              <span>{{ deliveryTime }}</span>
            </p>
          </div>
        </aside>
      </div>

      <div v-if="isFamilyPack" class="FamilyPackUsp row">
        <div class="col-md-4" v-for="(usp, index) in cartDetails.usps" :key="index">
          <div class="FamilyPackUsp_item">
            <div class="img-holder">
              <img :src="usp.icon" :alt="usp.title">
            </div>
            <h5>{{ usp.title }}</h5>
            <ul>
              <li v-for="(text, index) in usp.contents" :key="index">{{ text }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
   <div> {{GAcartviewevent}} </div> 
    <generic-custom-code
      :generic-script="genericScript"
      :generic-html="genericHtml"
    />
  </div>
</template>

<script>
  import Product from 'components/Product'
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import { extractErrorMessage } from '@/utilities/common'
  import { remove, uniq, omit, flattenDepth, join, flatten } from 'lodash'
  import GenericCustomCode from 'components/GenericCustomCode'
  import ProductUsp from 'components/ProductUsp'
  import FpDiscountBox from 'components/FpDiscountBox'
  import checkoutStepCart from 'components/CheckoutStepCart'
  import { detectedCulture } from '@/utilities/common/culture'
  

  export default {
    name: 'shopping-cart',

    beforeRouteLeave (to, from, next) {
      const commonPageTitle = window.localStorage.getItem('commonPageTitle')
      if (commonPageTitle && to.name !== 'checkout') {
        document.title = commonPageTitle
      }
      if (to.name !== 'checkout') {
        window.localStorage.removeItem('storedCartItems')
      }
      next()
    },

    beforeRouteEnter (to, from, next) {
      if (from.name === null && to.query.modified !== 'true') {
        window.localStorage.removeItem('storedCartItems')
        window.localStorage.removeItem('bundlesWithPromotions')
      }
      next()
    },

    components: {
      Product,
      GenericCustomCode,
      ProductUsp,
      FpDiscountBox,
      checkoutStepCart
    },

    data () {
      return {
        isLoading: true,
        showDeferredPaymentDetails: false,
        isReloading: false,
        maxQuantityIsValid: true,
        reachMaxAllowedNumberError: null,
        invalidBundles: [],
        Loading: false,
        diabledQuantitySelector: false,
        isLoding: false,
        canadaLanguage: window.localStorage.getItem('canadaLanguage'),
        detectedCulture: detectedCulture,
        name: null,
        surName: null,
        fromEmail:null,
        subscriptionNumber:null,
      }
    },

    props: {
      color: {
        type: String,
        default: '#9b9b9b'
      },
      rhombusSize: {
        type: Number,
        default: 10
      }
    },

    computed: {
      ...mapState('culture', ['deliveryTime']),
      ...mapState('checkout', {
        cartDetails: state => state.cartDetails
      }),

      bundles () {
        return (this.$route.query.bundle && this.$route.query.bundle.split(',')) || null
      },

      storedCartItems () {
        return JSON.parse(window.sessionStorage.getItem('storedCartItems')) || null
      },

      bundlesWithQuantity () {
        if (this.storedCartItems) {
          return this.storedCartItems
          } else {
          if (this.coupon) {
            return this.bundles && this.bundles.map(bundle => ({
              name: bundle,
              quantity: 1,
              promotionCodes: [this.coupon]
            }))
        } else {
          return this.bundles && this.bundles.map(bundle => ({
            name: bundle,
            quantity: 1,
            promotionCodes: []
          }))
        }
       }
      },

      bundlesWithNullPromotion () {
        return this.bundlesWithQuantity.map(item => ({
          name: item.name,
          quantity: item.quantity,
          promotions: []
        }))
      },

      bundlesWithNullPromotionCodes () {
        return this.bundlesWithQuantity.map(item => ({
          name: item.name,
          quantity: item.quantity,
          promotionCodes: []
        }))
      },

      bundlesWithPromotions () {
        return this.cartDetails.groups.map(group => {
          return group.items.map(item => ({
            name: item.name,
            quantity: item.quantity,
            promotions: item.promotions
          }))
        })
      },

      previewBundle () {
        return flatten(this.bundlesWithPromotions) || this.bundlesWithNullPromotion
      },

      bundlesWithDetails () {
        let bundles = []
        this.cartDetails.groups.forEach(group => {
          group.items.forEach(item => {
            let price, frequency
            if (item.monthlyCharge != null) {
              price = item.monthlyCharge.original
              frequency = 1
            } else if (item.quarterlyCharge != null) {
              price = item.quarterlyCharge.original
              frequency = 3
            } else if (item.semiAnnualCharge != null) {
              price = item.semiAnnualCharge.original
              frequency = 6
            } else if (item.specificMonthsCharges && item.specificMonthsCharges.length > 0) {
              item.specificMonthsCharges.forEach(specificItem => {
                price = specificItem.charge.original
                frequency = specificItem.specificMonths
              })
            }
            bundles.push({
              name: item.name,
              quantity: item.quantity,
              ctn: item.philips12NC,
              price: price,
              frequency: frequency
            })
          })
        })
        return bundles
      },

      isFamilyPack () {
        return this.bundles && this.bundles.length > 1
      },

      coupon () {
        return this.$route.query.coupon || null
      },

      vatDescription () {
        return this.cartDetails.summary.payNow.hasExtraTax ? this.$t('common.product.info.excludeVat', 'Prices exclulding VAT') : this.$t('common.product.info.includeVat', 'Prices inclulding VAT')
      },

      genericScript () {
        return this.isFamilyPack ? this.cartDetails.genericScript : this.cartDetails.groups[0].items[0].genericScript
      },

      genericHtml () {
        return this.isFamilyPack ? this.cartDetails.genericHtml : this.cartDetails.groups[0].items[0].genericHtml
      },

      pageTitle () {
        return this.isFamilyPack ? this.cartDetails.pageTitle : this.cartDetails.groups[0].items[0].pageTitle
      },
      bundleflag (){ 
        if(this.cartDetails.groups[0].items[0].bundleAvailable === 'false'){
          return true 
        } 
      },
    /*-----cart Pageload event ---------*/
     GAcartviewevent(){ 
     this.trackGoogleAnalyticsSimple({
      trigger: 'ecommerce.checkout.cartview',
      event: 'ecommerceEvent',
      marketPlaceParticipant: 'complete-order',
      ecommerce: {
          currencyCode:this.cartDetails.groups[0].items[0].currencyCode,
          cart: {
            products:[ 
              { 
                       id: this.cartDetails.groups[0].items[0].philips12NC,
                      locale: this.detectedCulture.code,
                      quantity: this.bundlesWithQuantity[0].quantity, 
                      originalPrice: this.cartDetails.summary.payNow.original, 
                      catCode: this.cartDetails.groups[0].items[0].philips12NC, 
                      bundleType: this.bundles[0], 
                      marketPlaceParticipant: 'Philips'
                    
              }
            ] 
            
          }
      }
    
})
 
         
       }
    },

    metaInfo () {
      return {
        title: this.pageTitle || window.localStorage.getItem('checkoutPageTitle')
      }
    },

    methods: {
      toggleDeferredPaymentDetails () {
        this.showDeferredPaymentDetails = !this.showDeferredPaymentDetails
        if (this.showDeferredPaymentDetails) {
          this.trackConversion({
            name: 'interaction',
            description: 'link:show_breakdown'
          })
        } else {
          this.trackConversion({
            name: 'interaction',
            description: 'link:close_breakdown'
          })
        }
      },

       openModalStep2 () {
        this.$bus.$emit('open-modal', 'newFlowCancel')
      },

       openModalStep3 () {
        Vue.api.subscription.sendcancelemail(this.name,this.surName,this.fromEmail,this.subscriptionNumber)
        this.$bus.$emit('open-modal', 'newFlowCancel1')
        this.$bus.$emit('close-modal', 'newFlowCancel')

       },

      test () {
      this.$bus.$emit('close-modal', 'newFlowCancel1')
       window.location.reload()
       },

      lastBundles () {
        const storedCartItems = JSON.parse(window.sessionStorage.getItem('storedCartItems'))
        if (storedCartItems) {
          let lastBundle = []
          storedCartItems.forEach(element => {
            lastBundle.push(element.name)
          })
          window.localStorage.setItem('lastBundle', join(lastBundle))
        }
      },

      async updateBundleQuantity (quantity, bundleName) {
        this.diabledQuantitySelector = true
        this.reachMaxAllowedNumberError = null
        const currentBundleQuantity = this.bundlesWithQuantity.find(bundle => bundle.name === bundleName).quantity
        this.bundlesWithQuantity.find(bundle => bundle.name === bundleName).quantity = quantity
        try {
          await
            this.$store.dispatch('checkout/getCartDetails', {
              bundles: this.bundlesWithQuantity,
              excludePrice: true
            })
          this.Loading = true
          this.maxQuantityIsValid = true
          this.$store.dispatch('checkout/getCartDetails', {
            bundles: this.bundlesWithQuantity,
            excludePrice: false
          }).then((data) => {
            this.Loading = false
            this.updateCartItems(data)
            this.$store.commit('checkout/setCartDetails', data)
            this.diabledQuantitySelector = false
            Vue.api.cart.validateMaxQuantity(this.bundlesWithQuantity).then((data) => {
              this.maxQuantityIsValid = data.isValid
              this.invalidBundles = data.bundles
              this.reachMaxAllowedNumberError = null
            }).catch(error => {
              if (error.data.code && error.data.code === 'error.message.reachMaxAllowedNumber') {
                this.reachMaxAllowedNumberError = {
                  defaultValue: error.data.message,
                  ...error.data,
                  ...error.data.extraInfo
                }
              }
            })
          })
        } catch (error) {
          this.bundlesWithQuantity.find(bundle => bundle.name === bundleName).quantity = currentBundleQuantity
          this.$notify({
            type: 'error',
            title: extractErrorMessage(error)
          })
          this.diabledQuantitySelector = false
        }
        
      },

      async removeBundle (bundleName, ctn) {
        if (ctn === null) {
          ctn = ''
        }
        this.diabledQuantitySelector = true
        this.reachMaxAllowedNumberError = null
        const currentBundle = this.bundlesWithQuantity.find(bundle => bundle.name === bundleName)
        this.trackAjax({
          events: 'scRemove',
          products: `${ctn}`,
          type: 'o'
        })
        remove(this.bundlesWithQuantity, item => item.name === bundleName)
        try {
          await
            this.$store.dispatch('checkout/getCartDetails', {
              bundles: this.bundlesWithQuantity,
              excludePrice: true
            })
          this.Loading = true
          this.maxQuantityIsValid = true
          this.$store.dispatch('checkout/getCartDetails', {
            bundles: this.bundlesWithQuantity,
            excludePrice: false
          }).then((data) => {
            this.Loading = false
            this.updateCartItems(data)
            this.$store.commit('checkout/setCartDetails', data)
            this.diabledQuantitySelector = false
            Vue.api.cart.validateMaxQuantity(this.bundlesWithQuantity).then((data) => {
              this.maxQuantityIsValid = data.isValid
              this.invalidBundles = data.bundles
              this.reachMaxAllowedNumberError = null
            }).catch(error => {
              if (error.data.code && error.data.code === 'error.message.reachMaxAllowedNumber') {
                this.reachMaxAllowedNumberError = {
                  defaultValue: error.data.message,
                  ...error.data,
                  ...error.data.extraInfo
                }
              }
            })
          })
        } catch (error) {
          this.bundlesWithQuantity.push(currentBundle)
          this.$notify({
            type: 'error',
            title: extractErrorMessage(error)
          })
          this.diabledQuantitySelector = false
        }
          this.trackGoogleAnalyticsSimple({
          trigger: 'ecommerce.cart.add',
          event: 'ecommerceEvent', 
           ecommerce: {
             currencyCode: this.cartDetails.groups[0].items[0].currencyCode,
              add: {
              actionField: {list: this.bundles[0]},  
              products: [
                {
                     id: this.cartDetails.groups[0].items[0].philips12NC,
                     quantity: this.bundlesWithQuantity[0].quantity,
                     price:this.bundlesWithDetails[0].price,   
                     catCode: this.cartDetails.groups[0].items[0].philips12NC,  
                     bundleType: this.bundles[0],
                     isSubscription: '{{isSubscription}}',
                     marketPlaceParticipant: 'Philips' 
                     
                }
              ]   
         
              },
               cart: {
                 id:this.cartDetails.groups[0].items[0].philips12NC,
            products: [
                {
                    id: this.cartDetails.groups[0].items[0].philips12NC,
                     quantity: this.bundlesWithQuantity[0].quantity,
                     price:this.bundlesWithDetails[0].price,  
                     catCode: this.cartDetails.groups[0].items[0].philips12NC,  
                     bundleType: this.bundles[0],
                     isSubscription: '{{isSubscription}}',
                     marketPlaceParticipant: 'Philips' 
                     
           }
            ]
               }
           }
        })
      },

      updateCartItems (cartDetails) {
        Object.assign({}, this.cartDetails)
        window.sessionStorage.setItem('storedCartItems', JSON.stringify(this.bundlesWithQuantity))
        this.lastBundles()
        window.sessionStorage.setItem('bundlesWithPromotions', JSON.stringify(flattenDepth(this.bundlesWithPromotions), 1))
      }
    },

    tasks (t) {
      return {
        submitCartTask: t(async function () {  
          this.isReloading = true
          this.reachMaxAllowedNumberError = null
          window.sessionStorage.setItem('bundlesWithQuantity', JSON.stringify(this.bundlesWithQuantity))
          window.sessionStorage.setItem('storedCartItems', JSON.stringify(this.bundlesWithQuantity))
          const { isValid, bundles } = await Vue.api.cart.validateMaxQuantity(this.bundlesWithQuantity)
          this.maxQuantityIsValid = isValid
          this.invalidBundles = bundles
          if (this.maxQuantityIsValid) {
            const bundlesInfor = {
              bundles: this.bundlesWithNullPromotion,
              genericScript: this.genericScript,
              genericHtml: this.genericHtml,
              pageTitle: this.pageTitle,
              phoneNumberRequired: this.cartDetails.phoneNumberRequired,
              phoneNumberVisible: this.cartDetails.phoneNumberVisible,
              termsTexts: this.cartDetails.termsTexts
            }
            window.localStorage.setItem('checkoutPageTitle', this.pageTitle)
            window.sessionStorage.setItem('bundlesInfor', JSON.stringify(bundlesInfor))
            window.sessionStorage.setItem('subscriptionInfo', JSON.stringify(this.bundlesWithDetails))
            if (this.canadaLanguage) {
              this.$router.replace({
                name: 'checkout',
                query: {
                  bundle: this.$route.query.bundle,
                  language: this.canadaLanguage
                }
              })
            } else {
              this.$router.replace({
                name: 'checkout',
                query: {
                  bundle: this.$route.query.bundle
                }
              })
            }
            this.isLoding = true
          }
          /*------Checkout step--------*/
           this.trackGoogleAnalyticsSimple({  
              trigger: 'ecommerce.checkout.step',
              event: 'ecommerceEvent',
              marketPlaceParticipant: 'Philips',
              ecommerce: {
              currencyCode: this.cartDetails.groups[0].items[0].currencyCode,
              purchase: {
              checkout: {
                  step: 'Login',
                },

                 products: [
                { 
                       id: this.cartDetails.groups[0].items[0].philips12NC, 
                       locale: this.detectedCulture.code,
                       quantity: this.bundlesWithQuantity[0].quantity,
                       originalPrice: this.cartDetails.summary.payNow.original,
                       bundleType: this.bundles[0],
                       marketPlaceParticipant: 'Philips',
                }
                 ]
                
              }
            } 
        })

        }).onError(function (task) {
          if (task.error.data && task.error.data.code === 'error.message.reachMaxAllowedNumber') {
            this.reachMaxAllowedNumberError = {
              defaultValue: task.error.data.message,
              ...task.error.data,
              ...task.error.data.extraInfo
            }
          } else {
            this.$notify({
              type: 'error',
              title: extractErrorMessage(task.error)
            })
          }
        }).onFinish(task => {
          this.isReloading = false
        })
      }
    },

    async created () {
      try {
        const bundle = this.$route.query.bundle
        const bundeleStorage = window.localStorage.getItem('lastBundle')
        if (bundle) {
          const uniqBundle = uniq(bundle.split(',')).join(',')
          window.localStorage.setItem('lastBundle', uniqBundle)
          let routeQuery
          if (this.canadaLanguage) {
            if (this.storedCartItems) {
              routeQuery = Object.assign({}, this.$route.query, { bundle: uniqBundle, modified: 'true', language: this.canadaLanguage })
            } else {
              routeQuery = Object.assign({}, omit(this.$route.query, ['modified', 'language']), { bundle: uniqBundle, language: this.canadaLanguage })
            }
            this.$router.replace({
              name: this.$route.name,
              query: routeQuery
            })
          } else {
            if (this.storedCartItems) {
              routeQuery = Object.assign({}, this.$route.query, { bundle: uniqBundle, modified: 'true' })
            } else {
              routeQuery = Object.assign({}, omit(this.$route.query, ['modified']), { bundle: uniqBundle })
            }
            this.$router.replace({
              name: this.$route.name,
              query: routeQuery
            })
          }
        } else {
          if (this.canadaLanguage) {
            this.$router.replace({
              name: this.$route.name,
              query: {
                bundle: bundeleStorage,
                modified: 'true',
                language: this.canadaLanguage
              }
            })
          } else {
            this.$router.replace({
              name: this.$route.name,
              query: {
                bundle: bundeleStorage,
                modified: 'true'
              }
            })
          }
        }
        await
          this.$store.dispatch('checkout/getCartDetails', {
            bundles: this.bundlesWithQuantity,
            excludePrice: true
          })
        this.isLoading = false
        this.Loading = true
        this.$store.dispatch('checkout/getCartDetails', {
          bundles: this.bundlesWithQuantity,
          excludePrice: false
        }).then((data) => {
          this.Loading = false
          this.$store.commit('checkout/setCartDetails', data)

          this.bundlesWithDetails.forEach(item => {
            this.trackAjax({
              events: 'event110',
              products: `;${item.ctn};${item.quantity};${item.price};;frequency=${item.frequency}`
            })
          })
          this.isLoading = false
        }).catch(error => {
          if (error.data.code === 'error.message.applyPromotionIsDuplicated') {
            this.$store.dispatch('checkout/getCartDetails', {
              bundles: this.bundlesWithNullPromotionCodes,
              excludePrice: false
            }).then((data) => {
              this.Loading = false
              this.$store.commit('checkout/setCartDetails', data)

              this.bundlesWithDetails.forEach(item => {
                this.trackAjax({
                  events: 'event110',
                  products: `;${item.ctn};${item.quantity};${item.price};;frequency=${item.frequency}`
                })
              })
            })
            this.isLoading = false
          }
        })
      } catch (error) {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
        this.isLoading = false
      }
    }
  }
</script>

<style lang="scss">
  .ShoppingCart-new {
    color: #212121;

    .container-cart {
      padding-top: .24rem;
      padding-bottom: .24rem;

      @include media (tablet) {
        padding-top: .4rem;
        padding-bottom: .4rem;
      }
    }

    &_body {
      position: relative;

      @include media (tablet) {
        display: flex;
        flex-wrap: wrap;
      }

      @include media (desktop) {
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: flex-start;
      }
    }

    .title {
      font-size: .24rem;
      line-height: .33rem;
      font-weight: 300;
      margin-bottom: .2rem;

      @include media (tablet) {
        font-size: .32rem;
        line-height: .42rem;
        margin-bottom: .3rem;
      }
    }

    .cancelDE {
      display: flex;
      width: 100%;
      border: 1px solid #ccc;
      margin-top: 50px;
      padding: 20px;
      background-color: #e8e8e8;

      .demo1 {
        margin-left: auto;
      }

      .newFlowCancelDE_popUp {
        text-align: center;
      }

      .contentDE {
        text-align: start;
      }

      .AppButton {
        width: 100%;
      }
    }

    .ShoppingCartItems {
      @include media (desktop) {
        width: 8.38rem;
      }

      &-type {
        margin-bottom: .32rem;

        @include media (desktop) {
          margin-bottom: .71rem;

          &:last-of-type {
            margin-bottom: 0;
          }
        }
      }

      &_header {
        display: flex;
        align-items: center;
        justify-content: center;

        @include media(tablet) {
          display: block;
        }

        &::before {
          content: '';
          position: absolute;
          height: .01rem;
          background-color: #e8e8e8;
          left: 0;
          width: 100%;

          @include media(tablet) {
            display: none;
          }
        }

        .title-subscriptionType {
          position: relative;
          background: #fff;
          padding: 0 .2rem;
          font-size: .2rem;
          line-height: .28rem;
          font-weight: 300;

          @include media(tablet) {
            padding: 0;
          }
        }
      }

      &_body {
        @include media (tablet) {
          padding: 0 .24rem 0 0;
        }

        .Product {
          position: relative;
          display: flex;
          flex-direction: column;
          padding: .4rem 0 .32rem;
          text-align: center;
          border-bottom: .01rem solid #e8e8e8;

          &:last-of-type {
            border: none;
          }

          @include media (tablet) {
            padding: .24rem 0 .5rem;
            flex-direction: row;
          }

          &_btn-remove {
            position: absolute;
            top: .17rem;
            right: 0;
            font-weight: 500;
            font-size: .14rem;
            line-height: .24rem;
            color: $blue;

            @include media(tablet) {
              top: auto;
              bottom: .15rem;
            }
          }

          .img-holder {
            width: 1.6rem;
            height: 1.6rem;
            padding: .1rem;
            margin-bottom: .2rem;

            @include media (tablet) {
              flex: none;
              width: 2.2rem;
              height: 2.2rem;
              margin-bottom: 0;
            }
          }

          &_text {
            margin-bottom: .13rem;

            @include media (tablet) {
              margin-bottom: 0;
              text-align: left;
              padding: 0 .05rem;
            }
          }

          &_name {
            font-size: .16rem;
            line-height: .22rem;
            color: #212121;
            margin-bottom: 0;

            @include media (tablet) {
              font-size: .2rem;
              line-height: .28rem;
            }
          }

          &_description {
            font-size: .16rem;
            line-height: .24rem;
            color: #212121;
            font-weight: 300;
          }

          &_quantity {
            display: flex;
            justify-content: center;
          }

          &_price {
            margin-bottom: .3rem;

            @include media (tablet) {
              order: 1;
              margin-bottom: 0;
              text-align: right;
            }

            &_item {
              display: flex;
              flex-direction: column;
              border-bottom: .01rem solid #e8e8e8;
              padding: .05rem;

              &:last-of-type {
                border-bottom: none;
              }

              @include media (tablet) {
                border: none;
                padding: 0;
                margin-bottom: .11rem;

                &:last-of-type {
                  margin-bottom: 0;
                }
              }

              .discount,
              .origin {
                font-size: .16rem;
                line-height: .24rem;
                font-weight: 700;
                display: block;
              }
            }

            span {
              font-size: .14rem;
              line-height: .19rem;
            }

            .origin.has-discount {
              font-size: .14rem;
              line-height: .19rem;
              font-weight: 400;
              color: #9e9e9e;
              text-decoration: line-through;
            }
          }
        }

        .AppSpinner {
          bottom: 20%;
          position: absolute;

          @include media (tablet) {
            right: 0;
            top: 40%;
          }
        }
      }
    }

    aside {
      @include media (tablet) {
        padding: .24rem .32rem 0;
        border: .01rem solid #e8e8e8;
        border-radius: .08rem;
        overflow: hidden;
        width: 100%;
      }

      @include media (desktop) {
        width: 4.12rem;
      }
    }

    .ShoppingCartPayment {
      margin-bottom: .3rem;
      position: relative;

      &-now {
        margin-bottom: .3rem;

        .btn-toggle {
          align-items: center;
          font-size: .16rem;
          line-height: .24rem;
          color: $blue;
          font-weight: 500;
          cursor: pointer;
        }

        p {
          display: flex;
          justify-content: space-between;
        }

        &_item {
          font-size: .16rem;
          line-height: .24rem;
          margin-bottom: .14rem;

          p {
            margin-bottom: .08rem;

            &:last-of-type {
              margin-bottom: 0;
            }

            .free {
              font-weight: bold;
              color: $green;
            }
          }

          .deliver {
            .green {
              color: #5f9920;
              line-height: .25rem;
              font-weight: bold;
              font-size: .17rem;
            }
          }
        }

        &_total {
          font-size: .2rem;
          line-height: .28rem;
          font-weight: 700;
          padding: .1rem 0;
          border-top: .01rem solid #696969;
        }
      }

      &-deferred {
        h4 {
          font-size: .16rem;
          line-height: .24rem;
          margin-bottom: .16rem;
        }

        &_item {
          margin-bottom: .14rem;

          &_header {
            display: flex;
            justify-content: space-between;
            font-size: .16rem;
            line-height: .24rem;

            p {
              .date {
                font-size: .12rem;
                line-height: .17rem;
                color: #787878;
              }

              .discount {
                font-weight: 700;
                color: $orange;
              }

              .original {
                font-weight: 700;

                &.has-discount {
                  text-decoration: line-through;
                  font-weight: 400;
                  font-size: .12rem;
                  line-height: .17rem;
                  color: #9e9e9e;
                }
              }
            }
          }

          .text-right {
            .discount,
            .original {
              display: block;
            }
          }

          &_body {
            font-size: .12rem;
            line-height: .17rem;
            padding-left: .15rem;
            margin-top: .16rem;
            border-left: .01rem solid #e8e8e8;

            > div {
              margin-bottom: .12rem;

              p {
                display: flex;
                justify-content: space-between;
              }

              &:last-of-type {
                margin-bottom: 0;
              }
            }

            .description {
              display: inline-flex;
              flex-direction: column;
              width: 2.32rem;
            }

            .label {
              color: #787878;
              font-weight: 700;
            }

            .discount {
              color: $orange;
            }
          }
        }

        .btn-toggle {
          display: flex;
          align-items: center;
          font-size: .16rem;
          line-height: .24rem;
          color: $blue;
          font-weight: 500;
          cursor: pointer;

          .icon {
            width: .12rem;
            height: .12rem;
            margin: 0 .06rem;
            color: #212121;
          }

          &.expand {
            .icon {
              transform: rotate(180deg);
            }
          }
        }

        .toggle-externals {
          margin-top: .4rem;
        }
      }

      .AppSpinner {
        position: relative;
        top: 50%;
        left: 50%;
      }
    }

    .AppButton-submitCart {
      font-size: .16rem;
      line-height: .22rem;
      // padding: .13rem;
      width: 100%;
      background-color: #e26d00;

      .AppButton {
        width: 100%;
      }
    }

    .tip-error-maxQuantity {
      p {
        margin-bottom: .05rem;

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }

    .DeliveryInfo {
      margin: .24rem -.15rem 0;
      background: #164776;
      padding: .23rem .15rem;

      @include media (tablet) {
        margin: .32rem -.32rem 0;
        padding: .23rem .32rem;
      }

      .icon {
        width: .21rem;
        height: .18rem;
        margin-right: .12rem;
      }

      .text {
        display: inline-flex;
        flex-direction: column;
        font-size: .16rem;
        line-height: .24rem;
        font-weight: 400;
        color: #fff;
      }
    }

    .FamilyPackUsp {
      margin-top: .5rem;

      @include media (tablet) {
        margin-top: .8rem;
      }

      > div {
        margin-bottom: .3rem;

        &:last-of-type {
          .FamilyPackUsp_item {
            padding-bottom: 0;
            border: none;
          }
        }

        @include media (tablet) {
          border-right: .01rem solid #e8e8e8;

          &:nth-of-type(3n),
          &:last-of-type {
            border: none;
          }
        }

        @include media(desktop) {
          padding: 0 .3rem;
        }
      }

      &_item {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-bottom: .3rem;
        border-bottom: .01rem solid #e8e8e8;

        @include media(tablet) {
          padding-bottom: 0;
          border: none;
        }

        .img-holder {
          width: .24rem;
          height: .24rem;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        h5 {
          font-size: .14rem;
          font-weight: 700;
          line-height: .21rem;
          margin: .07rem 0 .24rem;
        }

        ul {
          font-size: .12rem;
          line-height: .22rem;
          width: 100%;
        }
      }
    }

    .SingleBundleUsp {
      margin-top: .5rem;

      @include media (tablet) {
        margin-top: 1rem;
      }
    }
  }
</style>
